if (!customElements.get("before-n-after")) {
  class BeforeNAfter extends HTMLElement {
    constructor() {
      super();

      this.hasAnimated = false;
      this.afterImageContainer = this.querySelector(".after-image__wrapper");
      this.afterImage = this.querySelector(".after-image");
      this.divider = this.querySelector(".divider");

      window.initLazyScript(this, this.init.bind(this));
      
    }

    init() {

      this.handleResize();

      // Disable the default dragging behaviour of img elements
      this.querySelectorAll('img').forEach((img) => {
        img.draggable = false;
      });

      this.setAttribute("loaded", "");
    }

    connectedCallback() {
      this.handleResizeHandler = this.handleResize.bind(this);
      window.addEventListener("resize", this.handleResizeHandler);
      
      this.dragStartHandler = this.handleDragStart.bind(this);
      this.dragEndHandler = this.handleDragEnd.bind(this);
      this.dragHandler = this.handleDrag.bind(this);
      
      this.addEventListener('touchstart', this.dragStartHandler, { passive: true });
      this.addEventListener('touchend', this.dragEndHandler, { passive: true });      
      this.addEventListener('touchmove', this.dragHandler, { passive: true });  
      
      this.divider.addEventListener("mousedown", this.dragStartHandler);
      this.divider.addEventListener("mouseup", this.dragEndHandler);
      this.addEventListener("mouseleave", this.dragEndHandler);
      this.addEventListener("mousemove", this.dragHandler);

      if ('IntersectionObserver' in window) {
        const options = {
          root: null,
          rootMargin: '0px',
          threshold: 0.5, // Trigger when 50% of the component is visible
        };
        this.observer = new IntersectionObserver(this.handleIntersect.bind(this), options);
        this.observer.observe(this);
      }
    }

    disconnectedCallback() {
      window.removeEventListener("wheel", this.handleResizeHandler);
      
      this.removeEventListener("touchstart", this.dragStartHandler);
      this.removeEventListener("touchend", this.dragEndHandler);
      this.removeEventListener("touchmove", this.dragHandler);
      
      this.divider.removeEventListener("mousedown", this.dragStartHandler);
      this.divider.removeEventListener("mouseup", this.dragEndHandler);
      this.removeEventListener("mouseleave", this.dragEndHandler);
      this.removeEventListener("mousemove", this.dragHandler);

      if (this.observer) {
        this.observer.disconnect();
      }
    }

    handleIntersect(entries) {
      entries.forEach((entry) => {
        if (entry.isIntersecting && !this.hasAnimated) {
          // Add a small delay to ensure everything is rendered
          setTimeout(() => {
            this.animateSlider();
          }, 300);

          // Disconnect observer after first animation
          if (this.observer) {
            this.observer.disconnect();
          }
        }
      });
    }

    /**
     * Animate the slider handle to give users a hint about the interaction
     */
    animateSlider() {
      if (this.hasAnimated) return;

      this.hasAnimated = true;

      // Enable transitions for smooth animation
      this.afterImage.style.transition = 'width 0.5s ease-in-out';
      this.divider.style.transition = 'left 0.5s ease-in-out';

      // Create a subtle sliding animation
      setTimeout(() => {
      this.afterImage.style.width = "60%";
      this.divider.style.left = "40%";
      }, 100);

      setTimeout(() => {
      this.afterImage.style.width = "40%";
      this.divider.style.left = "60%";
      }, 600);

      setTimeout(() => {
      this.afterImage.style.width = "50%";
      this.divider.style.left = "50%";
      }, 1100);

      setTimeout(() => {
      // Remove transition after animation
      this.afterImage.style.transition = ''
      this.divider.style.transition = '';
      }, 1600);
    }

    /**
     * Handles 'mousedown' or 'touchstart' events on the carousel element.
     * @param {object} evt - Event object.
     */
    handleDragStart(evt) {
      this.dragstart = true;
      this.divider.classList.add("is-grabbing");
      this.classList.add("is-grabbing");
    }

    /**
     * Handles 'mouseup' or 'touchend' events on the carousel element.
     */
    handleDragEnd() {
      this.dragstart = false;
      this.divider.classList.remove("is-grabbing");
      this.classList.remove("is-grabbing");
    }

    /**
     * Handles 'mousemove' or 'touchmove' events on the carousel element.
     * @param {object} evt - Event object.
     */
    handleDrag(evt) {
      if (!this.dragstart) return;
      if (evt.type == 'mousemove') evt.preventDefault();

      let x = evt.type === "touchmove" ? evt.touches[0].clientX : evt.clientX; //get current coordinate
      let containerWidth = this.offsetWidth;
      let containerLeft = this.offsetLeft;

      let modifiedCurrentPoint = x - containerLeft;

      if (modifiedCurrentPoint >= 0 && modifiedCurrentPoint <= containerWidth) {

        let newWidth = (modifiedCurrentPoint * 100) / containerWidth;

        this.afterImage.style.width = 100 - newWidth + "%";
        this.divider.style.left = newWidth + "%";
      }
    }

    handleResize() {
      this.afterImageContainer.style.width = this.offsetWidth + "px";
    }
  }

  customElements.define("before-n-after", BeforeNAfter);
}
